import styled from 'styled-components';

const InternalLayout = styled.div`
  height: var(--btn-size);
  display: flex;
  align-items: center;
  gap: min(var(--btn-size) / 4, 0.25rem);
  position: relative;
  font-size: var(--btn-font-size);
  font-weight: var(--theme-font-weight-control);
  justify-content: center;
`;

export default InternalLayout;
